/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Regular_User_DescInputs */

const es_tyc_definitions_regular_user_desc = /** @type {(inputs: Tyc_Definitions_Regular_User_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario sin privilegios de administrador.`)
};

const en_tyc_definitions_regular_user_desc = /** @type {(inputs: Tyc_Definitions_Regular_User_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A User without administrator privileges.`)
};

/**
* | output |
* | --- |
* | "A User without administrator privileges." |
*
* @param {Tyc_Definitions_Regular_User_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_regular_user_desc = /** @type {((inputs?: Tyc_Definitions_Regular_User_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Regular_User_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_regular_user_desc(inputs)
	return en_tyc_definitions_regular_user_desc(inputs)
});
export { tyc_definitions_regular_user_desc as "tyc.definitions.regular_user_desc" }